import React from 'react';
import SmoothSliderImage from 'client/components/ImageLayout/SmoothSliderImageV2';
import Box from '@ff/ui/Box';
import { styled } from '@ff/ui';
import { colors } from 'client/v3/typography';

export type OptionsCarouselProps = {
  currentOption: string;
  current: {
    exteriorCode: string;
    wheelsCode: string;
    interiorCode: string;
  }
  exterior: {
    code: string;
    wheels: {
      code: string;
      images: string[];
    }[];
  }[];
  wheels: {
    code: string;
    exterior: {
      code: string;
      images: string[]
    }[];
  }[];
  interior: {
    code: string;
    images: string[];
  }[];
  otherImages?: string[];
}

export default function OptionsCarousel(props: OptionsCarouselProps) {
  const {
    currentOption,
    current: {
      exteriorCode: currentExteriorCode,
      wheelsCode: currentWheelsCode,
      interiorCode: currentInteriorCode
    },
    exterior: allExteriorImages,
    wheels: allWheelsImages,
    interior: allInteriorImages,
    otherImages,
  } = props;

  // find the exterior images by given exterior and wheels
  const currentExterior = allExteriorImages.find(e => e.code === currentExteriorCode);
  let currentExteriorWithWheels;
  if(currentExterior){
    currentExteriorWithWheels = currentExterior.wheels.find(w => w.code === currentWheelsCode);
    // if can't find any exterior images with given wheels, use the first exterior images with any wheels 
    if(!currentExteriorWithWheels){
      currentExteriorWithWheels = currentExterior.wheels[0]
    }
  }
  const displayedExteriorImages = currentExteriorWithWheels?.images?.map(
    (i) => ({ src: i, scaleRatio: 1.5 })
  ) || [];

  // find the wheels images by given wheels and exterior
  const currentWheels = allWheelsImages.find(w => w.code === currentWheelsCode);
  let currentWheelsWithExterior;
  if(currentWheels){
    currentWheelsWithExterior = currentWheels.exterior.find(e => e.code === currentExteriorCode);
    // if can't find any wheels images by given exterior,use the first wheels images with any exterior 
    if(!currentWheelsWithExterior){
      currentWheelsWithExterior = currentWheels.exterior[0];
    }
  }
  const displayedWheelsImages = currentWheelsWithExterior?.images?.map(
    i => ({ src: i, scaleRatio: 1, objectPosition: 'bottom' })
  ) || [];

  const displayedInteriorImages = allInteriorImages
    .find((i) => i.code === currentInteriorCode)
    ?.images?.map((i) => ({ src: i, scaleRatio: 1 })) || [];

  const displayedOtherImages = otherImages?.map(i => ({src: i, scaleRatio: 1})) || [];

  const  allDisplayedImages = displayedExteriorImages
      .concat(displayedWheelsImages)
      .concat(displayedInteriorImages)
      .concat(displayedOtherImages);

  let currentImageIndex;
  if(currentOption === 'WHL'){
    currentImageIndex = displayedExteriorImages.length
  }else if(currentOption === 'INT'){
    currentImageIndex = displayedExteriorImages.length + displayedWheelsImages.length;
  }else{
    currentImageIndex = 0;
  }

  return (
    <>
      <DesktopImageContainer>
        <SmoothSliderImage
          currentImageIndex={currentImageIndex}
          images={allDisplayedImages}
          swiperNavigationColor='black'
          paginationEnabled={true}
          backgroundColor={colors.background3}
        />
      </DesktopImageContainer>
      <MobileImageContainer>
        <SmoothSliderImage
          currentImageIndex={false} //don't change current image by option position in mobile page
          images={allDisplayedImages}
          swiperNavigationColor='black'
          paginationEnabled={true}
          backgroundColor={colors.background3}
        />
      </MobileImageContainer>
    </>
  );
}

const DesktopImageContainer = styled(Box)(({ theme }) => ({
  display: 'none',
  [theme.mediaQueries.md]: {
    display: 'block',
    minWidth: '400px',
  }
}));

const MobileImageContainer = styled(Box)(({ theme }) => ({
  display: 'block',
  [theme.mediaQueries.md]: {
    display: 'none'
  }
}));
